import { createContext, useContext } from 'react';

import type { DraftRegistry } from './draft-registry';

export interface DraftManagerContextValue {
  readonly registry: DraftRegistry;
}

export const DraftManagerContext = createContext<DraftManagerContextValue | null>(null);

export function useDraftManagerContext(): DraftManagerContextValue {
  const ctx = useContext(DraftManagerContext);
  if (!ctx) {
    throw new Error(
      '[DraftManager] useDraftManagerContext must be used within DraftManagerProvider.',
    );
  }
  return ctx;
}
